import React from 'react';

const CarouselIndicators = ({count}) => {
    return (
        <li
            data-target="#carouselExampleIndicators"
            data-slide-to={count}
            className={count === 0 ? 'active' : ''}>
        </li>
    );
};

export default CarouselIndicators;
